@if (auth.isLoading$ | async) {
<div class="container">
  <app-loading></app-loading>
</div>
} @else {
@if (!bannerDismissed) {
<div class="banner" role="region" aria-live="polite">
  <div class="container banner__inner">
    <div class="banner__content">
      <p>This software is in its <strong>Alpha</strong> stage of development. While it may be functional, it is still a
        work in progress
        and
        may contain bugs, incomplete features, or performance issues. Use at your own risk and expect potential
        instability.
        We recommend backing up any important data and reporting any issues you encounter. Your feedback is valuable in
        helping us improve this product.</p>
    </div>
    <button class="banner__dismiss" type="button" aria-label="Dismiss banner" (click)="dismissBanner()">✕</button>
  </div>
</div>
}
<app-hero></app-hero>
<app-home-content></app-home-content>
}


@if (auth.isAuthenticated$ | async) {
<div class="nav"><a routerLink="/geometry/0" position="end" ngbTooltip="Create a new job">+</a></div>
<div>
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiError}}
  </div>
  }
  <div class="jobTiles">
    @for (job of this.jobs; track job) {
    <a class="jobTile" routerLink="/geometry/{{job.id}}">
      <div class="jobTileContent {{this.getJobStatusClass(job.status)}}">
        <div class="jobImage {{this.getJobTypeClass(job.type)}}">
        </div>
        <div class="jobDetails">
          <!-- Display the job creation date -->
          <div class="jobCreation">
            {{job.creation_date | date:'HH:mm, dd MMM yyyy'}}{{getInitiator(job)}}
          </div>
          <!-- Display the job title link -->
          <div class="jobTitle">
            {{job.title}}
          </div>
          <!-- Display the job type -->
          <div class="jobType">
            {{this.helpers.getJobTypeString(job.type)}}
          </div>
          <!-- Display the job status -->
          <div class="jobStatus">
            {{this.helpers.getJobStatusString(job.status)}}
          </div>
          <!-- Display the job node -->
          <div class="jobNode">
            {{job.node_id}}
          </div>
        </div>
      </div>
    </a>
    }
  </div>
</div>
}
